export const SITE = {
  brand: "Patiala Engineering Works",
  short: "PEW",
  tagline: "Precision dies & rollers for the world's biscuit lines.",
  established: 2017,
  yearsLegacy: "15+",
  ceo: "Indermeet Singh",
  // Contact
  phone: "+91 98152 50356",
  whatsapp: "+91 98152 50356",
  email: "info@patialaengineeringworks.in",
  addressLine1: "11-A, Focal Area",
  addressLine2: "Patiala, Punjab — 147001, India",
  gst: "03**********1ZD",
  iec: "AUQ*****5D",
  industries: ["Bakery", "Dairy", "Confectionery", "Cookie & Cracker", "Snack Foods"],
  facts: [
    { k: "Years of legacy", v: "15+" },
    { k: "Industries served", v: "5+" },
    { k: "Tooling families", v: "6" },
    { k: "Export ready", v: "IEC certified" },
  ],
};
